/* unplugin-vue-components disabled */import __unplugin_components_3 from 'D:/hjj/bio_link_pc/src/components/empty.vue';
import { ElTimeline as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/timeline/style/css';
import { ElTimelineItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/timeline-item/style/css';
import { ElCard as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/card/style/css';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "justify-content": "space-between",
    "display": "flex"
  }
};
var _hoisted_2 = {
  class: "nodename"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  style: {
    "white-space": "pre-line"
  }
};
var _hoisted_5 = {
  key: 1,
  style: {
    "text-align": "left",
    "display": "flex",
    "line-height": "30px"
  }
};
var _hoisted_6 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  key: 0
};
import { watch } from "vue";
import { downloadUrl } from "@/util";
export default {
  __name: 'flowRecord',
  props: ["opinion", "type"],
  setup(__props) {
    var prop = __props;
    var flow_list = ref([]);
    watch(() => {
      return prop.opinion;
    }, val => {
      if (!val) {
        return false;
      }
      flow_list.value = prop.opinion;
      flow_list.value.map(x => {
        if (x.status == 3 && prop.type == "sample") {
          x.icon = "WarningFilled";
          x.type = "danger";
        } else if (x.status == 2 && prop.type == "sample") {
          x.icon = "Check";
          x.type = "success";
        }
        if (x.agree == 2 && prop.type == "quotation") {
          x.icon = "WarningFilled";
          x.type = "danger";
        } else if (x.agree == 1 && prop.type == "quotation") {
          x.icon = "Check";
          x.type = "success";
        } else {
          if (x.approval_status == 1) {
            x.agree = 1;
            x.icon = "Check";
            x.type = "success";
          }
        }
      });
    }, {
      immediate: true
    });
    var handledown = v => {
      downloadUrl(v.file_url, v.file_original_name);
    };
    return (_ctx, _cache) => {
      var _component_el_card = __unplugin_components_0;
      var _component_el_timeline_item = __unplugin_components_1;
      var _component_el_timeline = __unplugin_components_2;
      var _component_empty = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flow_list), (item, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            timestamp: item.updated_at,
            placement: "top",
            key: index,
            type: item.type,
            icon: item.icon,
            size: "large"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, null, {
              default: _withCtx(() => [_createElementVNode("p", _hoisted_1, [_createElementVNode("span", null, [_cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "flowtitle"
              }, "审批人：", -1)), _createElementVNode("span", null, _toDisplayString(item.handler_name || item.approver_user_name), 1)]), _createElementVNode("span", _hoisted_2, _toDisplayString(item.node_name), 1)]), _createElementVNode("p", null, [_cache[1] || (_cache[1] = _createElementVNode("span", {
                class: "flowtitle"
              }, "审批备注：", -1)), _createElementVNode("span", {
                class: _normalizeClass(item.agree != 1 ? 'reject' : '')
              }, _toDisplayString(item.audit_info || item.remark), 3)]), item.record ? (_openBlock(), _createElementBlock("p", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("span", {
                class: "flowtitle"
              }, "修改记录：", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(item.record), 1)])) : _createCommentVNode("", true), item.file_info && item.file_info[0] ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("span", {
                class: "flowtitle"
              }, "附件：", -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.file_info, v => {
                return _openBlock(), _createElementBlock("div", {
                  class: "link",
                  style: {
                    "padding-right": "10px"
                  },
                  onClick: $event => handledown(v),
                  key: v.file_id
                }, _toDisplayString(v.file_original_name), 9, _hoisted_7);
              }), 128))])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["timestamp", "type", "icon"]);
        }), 128))]),
        _: 1
      }), _unref(flow_list).length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_empty, {
        msg: "暂无流转记录"
      })])) : _createCommentVNode("", true)]);
    };
  }
};